import { createGlobalStyle } from 'styled-components'
import styled from 'styled-components'

export const GlobalStyle = createGlobalStyle`
    * { 
        scrollbar-width: none;
        -ms-overflow-style: none;
        ::-webkit-scrollbar {
            display: none;
        }

        word-break: break-word;
    }
    html {
        background-color: white;
    }
    body {
        overflow-x: hidden;
    }
    a {
        font-size: inherit !important;
    }

`

export const Container = styled.div`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: white;
`

export const Content = styled.div`
    flex-grow: 1;
`
